import React from "react";
import useIsMobile from "~/lib/hooks/useIsMobile";
import SuggestProductPopoverDesktop from "~/components/product/marketplace/SuggestProductPopoverDesktop";
import SuggestProductPopoverMobile from "~/components/product/marketplace/SuggestProductPopoverMobile";

interface ISuggestProductPopoverProps {
  isOpen: boolean;
  onRequestClose: () => any;
  onSuggestProduct: () => any;
  children: (popoverOptions: any) => any;
}

export default function SuggestProductPopover({
  isOpen,
  onRequestClose,
  onSuggestProduct,
  children,
}: ISuggestProductPopoverProps) {
  const isMobile = useIsMobile();

  if (isOpen && isMobile) {
    return <SuggestProductPopoverMobile onRequestClose={onRequestClose} onSuggestProduct={onSuggestProduct} />;
  }

  return (
    <SuggestProductPopoverDesktop
      isOpen={isOpen && !isMobile}
      onRequestClose={onRequestClose}
      onSuggestProduct={onSuggestProduct}
    >
      {children}
    </SuggestProductPopoverDesktop>
  );
}
